<template>
    <div class="row gx-3">
        <pc-label
            v-bind:label="label"
            v-bind:for-id="inputId"
            v-bind:show-required="required"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            class="col-12"
            v-on:help-clicked="emitHelpClicked" />
        <div class="col-12">
            <slot name="help" />
        </div>
        <pc-input-group v-bind:class="responsiveHelpers.standard">
            <!--
                GroupId is specified because although this is not part of a group,
                it is used to ensure the browser does not attempt to autofill multiple
                unrelated emails with the same address.
            -->
            <pc-input
                v-bind="binder"
                v-bind:group-id="element.DataFieldId"
                v-bind:autocomplete="BROWSER_AUTOCOMPLETE_TOKEN.email"
                v-bind:validation-group-id="inputId"
                data-test-role="textbox-element"
                inputmode="email"
                v-on="listeners" />
        </pc-input-group>
        <validation-render-helper
            v-bind:validation-error="validationError"
            v-bind:validation-group-id="inputId" />
    </div>
</template>

<script>
    import base, { VALIDATOR_TYPES, validationRenderHelper } from "./_elementBase";
    import { BROWSER_AUTOCOMPLETE_TOKEN } from "Util/browserAutocompleteConstants";

    export default {
        components: { validationRenderHelper },
        extends: base,
        data() {
            return {
                BROWSER_AUTOCOMPLETE_TOKEN
            };
        },
        methods: {
            getAdditionalValidatorOptions() {
                return [VALIDATOR_TYPES.email];
            }
        }
    };
</script>
